<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              輔翼會員 查詢
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center">
          <h4 class="font-weight-bold">輔翼會員 查詢</h4>
        </div>
      </div>

      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="電話"
        >
          <b-input-group>
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              type="text"
              v-model="phone"
              placeholder="請輸入手機號碼"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="會員代號(MemberCode)"
        >
          <b-input-group>
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              type="text"
              v-model="memberCode"
              placeholder="請輸入會員代號"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="會員唯一號(MemberSerNo)"
        >
          <b-input-group>
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              type="text"
              v-model="memberSerNo"
              placeholder="請輸入會員唯一號"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
        >
          <template #label>
            會員類別唯一碼
            <i
              class="mdi mdi-help-circle-outline"
              id="flaps-member-class-ser-no-tooltip"
            ></i>
            <b-tooltip
              target="flaps-member-class-ser-no-tooltip"
              triggers="hover"
              placement="right"
            >
              使用電話或會員代號查詢時，會員類別唯一碼為必填；僅以會員唯一號查詢時可選填。
            </b-tooltip>
          </template>
          <b-input-group>
            <b-form-input
              class="mb-2 mr-sm-2 mb-sm-0"
              type="text"
              v-model="memberClassSerNo"
              placeholder="請輸入會員類別唯一碼"
            ></b-form-input>
          </b-input-group>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
        >
          <b-button
            variant="info"
            @click="handleSearch"
            :disabled="isLoading"
          >
            查詢
          </b-button>
        </b-form-group>
        <editor
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="result"
          width="100%"
          height="300px"
          @init="editorInit"
          lang="json"
          theme="chrome"
          :disabled="!editable"
        >
        </editor>
      </b-overlay>
    </b-card>
  </div>
</template>

<style scoped lang="scss">
.group + .group {
  border-top: 1px solid #cdd6dc !important;
}
</style>
<script>
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import editor from "vue2-ace-editor";
import fileMixin from "@/mixins/uploadFile";
import flapsApi from "@/apis/flaps"
import organizationVariableApi from "@/apis/organization-variable";


export default {
  mixins: [fileMixin],
  components: { editor },
  validationConfig: {
    $lazy: true,
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {};
  },
  data() {
    return {
      code: null,
      phone: null,
      memberCode: null,
      memberSerNo: null,
      memberClassSerNo: null,
      result: "",
      color: "",
      isLoading: false,
      isSubmitting: false,
      formGroups: {},
      module: {},
      fetchedVariableId: null,
      canEdit: false,
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    orgId() {
      return this.organization.id;
    },
    editable() {
      return !this.isShownByVariableCode || this.canEdit
    },
  },
  async mounted() {
    if (!this.checkPermission([consts.HTY_FLAPS_SETTING_QUERY])) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33",
        })
        .then(() => {
          this.$router.push({
            name: "OrganizationVariableList",
          });
        });
    }

    let response = await organizationVariableApi.getByKey({
      org_code: this.orgId,
      key: "FLAPS-CONFIG",
    });
    let orgVariables = JSON.parse(response.data.data.value);
    this.memberClassSerNo = orgVariables.MemberClassSerNo || null;
  },
  methods: {
    editorInit() {
      require("brace/ext/language_tools");
      require("brace/mode/json");
      require("brace/mode/html");
      require("brace/theme/chrome");
    },
    async handleSearch() {
      const phone = (this.phone || "").trim();
      const memberCode = (this.memberCode || "").trim();
      const memberSerNo = (this.memberSerNo || "").trim();
      const memberClassSerNo = (this.memberClassSerNo || "").trim();
      const filledSearchFields = [phone, memberCode, memberSerNo].filter(Boolean).length;

      if (filledSearchFields === 0) {
        this.$swal.fire({
          type: "warning",
          text: "請至少輸入手機、會員代號、會員唯一號其中一項",
        });
        return;
      }

      if (filledSearchFields > 1) {
        this.$swal.fire({
          type: "warning",
          text: "手機、會員代號、會員唯一號僅允許輸入一個查詢條件",
        });
        return;
      }

      if ((phone || memberCode) && !memberClassSerNo) {
        this.$swal.fire({
          type: "warning",
          text: "使用電話或會員代號查詢時，必須輸入會員類別唯一碼",
        });
        return;
      }

      try {
        this.isSubmitting = true;
        this.result = "查詢中...";
        const params = {};
        if (phone) params.phone = phone;
        if (memberCode) params.member_code = memberCode;
        if (memberSerNo) params.member_ser_no = memberSerNo;
        if (memberClassSerNo) params.member_class_ser_no = memberClassSerNo;

        const result = await flapsApi.query(params);
        this.result = JSON.stringify(result.data, null, 2);
      } catch (error) {
        this.result = JSON.stringify(error.response?.data || error.message, null, 2);
      }
      this.isSubmitting = false;
    },

    async handleSubmit(redirect = true) {
      const result = await this.v$.$validate();
      if (!result) return;
      this.handleUpdate(redirect);
    },
    showSuccessPopup(redirect = true) {
      this.$swal
        .fire({
          type: "success",
          text: "修改成功",
        })
        .then(() => {
          if (redirect) {
            this.$router.push({
              name: this.isByMerchant
                ? "OrganizationVariableListByMerchant"
                : "OrganizationVariableList",
            });
          }
        });
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
  },
};
</script>

